import { NavLink } from "react-router-dom";
import "./BottomNav.css";

function BrowseIcon(): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.2" />
      <rect x="14" y="3" width="7" height="7" rx="1.2" />
      <rect x="3" y="14" width="7" height="7" rx="1.2" />
      <rect x="14" y="14" width="7" height="7" rx="1.2" />
    </svg>
  );
}

function SearchIcon(): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10.5" cy="10.5" r="6.5" />
      <line x1="20" y1="20" x2="15.5" y2="15.5" />
    </svg>
  );
}

function RequestsIcon(): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </svg>
  );
}

export function BottomNav(): React.JSX.Element {
  return (
    <nav className="bottom-nav">
      <NavLink to="/" end className="bottom-nav__link">
        <BrowseIcon />
        <span>Browse</span>
      </NavLink>
      <NavLink to="/search" className="bottom-nav__link">
        <SearchIcon />
        <span>Search</span>
      </NavLink>
      <NavLink to="/my-music" className="bottom-nav__link">
        <RequestsIcon />
        <span>My Music</span>
      </NavLink>
    </nav>
  );
}
